import generalSection from "../_section/section.class";
import {userInvestmentStatementUpload, adminInvestmentStatementUpload} from "./upload";
import DataForm from "./DataForm";
import problem from "../_section/section-problem.class";
import ApplicationForm from "./ApplicationForm";
import dayjs from "dayjs";

export class userInvestmentStatementSection extends generalSection {
    constructor(request, mortgage, props, statementUploadFactory = null) {
        super(request, mortgage, props, statementUploadFactory ?? userInvestmentStatementUpload);
        // Add missing date error

    }
}

export class adminInvestmentStatementSection extends userInvestmentStatementSection {
    constructor(request, mortgage, props) {
        super(request, mortgage, props, adminInvestmentStatementUpload);
        this.sortByDateProp('documentDate')
        this.DataForm = DataForm
        this.ApplicationForm = ApplicationForm
        this.setUploadsRanges(
            (() => {
                const activeUploads = [...this.uploads].reverse().filter(it => it.isActive && it.isVerifiable);
                return activeUploads.flatMap((upload, uploadIndex) => {
                    if (!upload?.dateData?.range?.ok) {

                        return [];
                    }
                    const nextUploadWithOpening = activeUploads.find((it, i) => i > uploadIndex && it?.dateData?.range?.from?.date);
                    const openingDateOfNextUpload = nextUploadWithOpening ? nextUploadWithOpening?.dateData?.range?.from?.date : null;
                    // if there are start or end props available, use them, as they are the dates on the alignment endDate/startDate
                    let thisEnd = upload?.dateData?.range?.to
                    let thisStart = upload?.dateData?.range?.from


                    // this now updates the current upload end date, if the next upload opening date is before it
                    if (thisEnd?.date && openingDateOfNextUpload && openingDateOfNextUpload.isBefore(thisEnd.date)) {
                        let neededEndDate = openingDateOfNextUpload
                        thisEnd = {
                                date: neededEndDate,

                            }

                    }

                    return [
                        {
                            start: thisStart,
                            end: thisEnd,
                            uploadId: upload.id,
                        }
                    ]
                })
            })()
        )
        this.setProblems( this.getProblems() )

    }
    getProblems() {
        const problems = this.problemsList.universalVerifiedUploadProblems();

        if (!problems.length){
            const iban = this.data?.accountNumber
            if (!iban) {
                return [
                    new problem({
                        type: "BUNDLE",
                        title: 'Account No not set',
                        message: 'Account No missing in Application Data',
                    })
                ]
            }
            else{
                let mismatch = false;
                this.activeUploads.forEach(upload => {
                    const problematic = upload.values.accountNumber && upload.values.accountNumber !== iban
                    if (problematic) {
                        mismatch = true;
                        upload.problems.push('Account No Mismatch')
                    }
                })
                if (mismatch) {
                    problems.push(new problem({
                        type: "BUNDLE",
                        title: 'Account No Mismatch',
                        message: 'Account No Mismatch',
                    }))
                }

            }
            if (!this?.progress?.requiredRanges){
                problems.push(...this.problemsList.summaryRangeTooShort(6, 'months'))
            }
            if (this?.progress?.requiredRanges){
                const start = this.progress.requiredRanges[0]?.start ? dayjs(this.progress.requiredRanges[0].start) : null;
                const end = this.progress.requiredRanges[0]?.end ? dayjs(this.progress.requiredRanges[0].end) : null;
                const expandedRange = this.calcExpandedRange(start, end);
                problems.push(...this.problemsList.missingInExpandedRange(expandedRange))
            }
            else if (this.statementAlignmentDate) {
                const expandedRange = this.calcExpandedRange(this.statementAlignmentDate.add(1,'day').subtract(6, 'months'), this.statementAlignmentDate);
                problems.push(...this.problemsList.missingInExpandedRange(expandedRange))
            }
        }


        return problems
    }

    get documentDate() {
        if (this.uploads[0] && this.uploads[0].values.documentDate) {
            return this.uploads[0].values.documentDate;
        }
        return null;
    }
    get closingBalance() {
        if (this.uploads[0] && this.uploads[0].values.closingBalance) {
            return this.uploads[0].values.closingBalance;
        }
        return null;
    }
    get startDate() {
        if (this.uploads[0] && this.uploads[0].values.startDate) {
            return this.uploads[0].values.startDate;
        }
        return null;
    }
    get accountNumber() {
        if (this.uploads[0] && this.uploads[0].values.accountNumber) {
            return this.uploads[0].values.accountNumber;
        }
        return null;
    }
    get mostRecentClosingBalance(){
        const sorted = [...this.activeUploads].sort((a,b) => {
            const aDate = a.values.documentDate
            const bDate = b.values.documentDate
            if (aDate && bDate){
                return bDate.valueOf() - aDate.valueOf()
            }
            else if (aDate){
                return -1
            }
            else if (bDate){
                return 1
            }
            else{
                return 0
            }
        })
        return sorted.length ? {
            uploadID : sorted[0].props.upload.id,
            balance: sorted[0].values.closingBalance,
        } : null;
    }

    getSectionSummary = () => {
        const lastBalanceUpload = this.activeUploads.sort((a,b) => {
            const aDate = a.values.documentDate
            const bDate = b.values.documentDate
            if (aDate && bDate){
                return bDate.valueOf() - aDate.valueOf()
            }
            else if (aDate){
                return -1
            }
            else if (bDate){
                return 1
            }
            else{
                return 0
            }
        })[0]
        return [
            {
                name: this.personalTitle,
                tags: [
                    {
                        name: 'Last Balance',
                        value: lastBalanceUpload?.values?.closingBalance
                    },
                    {
                        name: 'Last Balance Date',
                        value: lastBalanceUpload?.values?.documentDate?.format('D MMM YYYY') || 'Not Provided'
                    }
                ]
            }
        ]
    }
}